import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Typography, Statistic } from 'antd';
import {
  UserOutlined,
  DollarCircleOutlined,
  ArrowUpOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const StatCard = ({ title, value, icon, color, prefix, suffix }: { title: string; value: string | number; icon?: React.ReactNode; color?: string; prefix?: React.ReactNode; suffix?: React.ReactNode }) => (
  <Card>
    <Statistic
      title={<Text style={{ color }}>{title}</Text>}
      value={value}
      prefix={icon || prefix}
      suffix={suffix}
      valueStyle={{ color }}
    />
  </Card>
);

const Dashboard = () => {
  const { t } = useTranslation('dashboard');

  return (
    <div>
      <Title level={2} style={{ marginBottom: '24px' }}>
        {t('title')}
      </Title>
      
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <StatCard
            title={t('stats.activeUsers')}
            value="1,234"
            icon={<UserOutlined style={{ fontSize: '24px'}}/>}
            color="#52c41a"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <StatCard
            title={t('stats.revenue')}
            value="45678"
            prefix={<DollarCircleOutlined style={{ fontSize: '24px'}}/>}
            color="#faad14"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <StatCard
            title={t('stats.growth')}
            value={15}
            prefix={<ArrowUpOutlined style={{ fontSize: '24px'}}/>}
            suffix="%"
            color="#f5222d"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        <Col xs={24} md={16}>
          <Card title={t('widgets.salesOverview')}>
            <Text>{t('welcome')}</Text>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card title={t('widgets.notifications')}>
            <Text>{t('actions.viewAll')}</Text>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard; 